<template>
    <div class="selection similarVideo" v-if="content && content.length">
        <div class="selection__title">
            <h2>{{ title }}</h2>
        </div>
        <div class="selection__slider" v-if="content && content.length">
            <swiper
                :spaceBetween="10"
                :free-mode="true"
                :speed="800"
                :mousewheel="{
                    forceToAxis: true
                }"
                :breakpoints="breakpoints"
                :modules="modules"
                :navigation="{
                    prevEl: '.selection-prev',
                    nextEl: '.selection-next'
                }"
                @swiper="onSwiper"
            >
                <swiper-slide v-for="(item, index) in content" :key="index">
                    <!-- <img :src="item.thumbnail_big" alt="Tvcom" /> -->
                    <NewMovieCard :item="item" />
                </swiper-slide>
                <sliderNavigation
                    prevClass="selection-prev"
                    nextClass="selection-next"
                />
            </swiper>
        </div>
        <div class="list" v-else>
            <div class="selection__item loader" v-for="i in 10" :key="i"></div>
        </div>
    </div>
</template>

<script>
import sliderNavigation from "./main/sliderNavigation.vue";
// import { checkToken } from "../Api";
import NewMovieCard from "./NewMovieCard.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode, Navigation, Mousewheel } from "swiper/modules";
import "swiper/css";
export default {
    components: {
        Swiper,
        SwiperSlide,
        sliderNavigation,
        NewMovieCard
    },
    props: {
        title: {
            type: String
        },
        content: {
            type: Array
        }
    },
    data() {
        return {
            swiperInstance: null,
            breakpoints: {
                320: {
                    slidesPerView: "auto",
                    speed: 0
                },
                768: {
                    speed: 800,
                    slidesPerView: 2.5,
                    slidesPerGroup: 2
                },
                800: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                1400: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                1920: {
                    slidesPerView: 5.5,
                    slidesPerGroup: 5
                },
                2560: {
                    slidesPerView: 6,
                    slidesPerGroup: 6
                }
            }
        };
    },
    watch: {
        swiperInstance() {
            if (window.innerWidth <= 768) {
                this.swiperInstance.disable();
            }
        }
    },

    methods: {
        onSwiper(swiper) {
            this.swiperInstance = swiper;
        }
    },
    setup() {
        return {
            modules: [FreeMode, Navigation, Mousewheel]
        };
    }
};
</script>

<style lang="scss">
.selection {
    &.similarVideo {
        --paddingLeft: 0;
    }
    margin-bottom: 35px;
    &__title {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        padding: 0 var(--paddingLeft);
        h2 {
            font-size: 26px;
            color: #efefef;
        }
    }
    &__slider {
        position: relative;
        .swiper {
            width: 100%;
            padding-left: var(--paddingLeft);
            padding-top: 10px;
            padding-bottom: 10px;
            &-slide {
                height: auto;
                .card {
                    aspect-ratio: 23/35;
                }
            }
        }
    }
    &__item {
        width: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: 0.3s ease;
        background: #1c1c1c;
        &:hover {
            scale: 1.05;
        }
        &_img {
            height: 160px;
            position: relative;
            img {
                height: 100%;
            }
        }
        &_info {
            padding: 20px;
            display: flex;
            flex-direction: column;
            width: 280px;
            .name {
                font-size: 18px;
                margin-bottom: 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .year {
                margin-bottom: 5px;
                font-size: 16px;
            }
            .country {
                font-size: 16px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    &.similarVideo {
        .selection__item {
            &.loader {
                width: calc(100vw / 3);
                height: 160px;
                border-radius: 5px;
                background: linear-gradient(
                    100deg,
                    #3f3f3f 30%,
                    #e41a4b 50%,
                    #3f3f3f 70%
                );
                background-size: 500%;
                animation: loading 1s ease-in-out infinite;
            }
        }
    }
    .list {
        display: flex;
        overflow: hidden;
        gap: 10px;
        padding-left: var(--paddingLeft);
    }
}
@keyframes loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}
@media screen and (min-width: 1920px) {
    .selection {
        &.similarVideo {
            .selection__item {
                &.loader {
                    min-width: calc(100vw / 4);
                }
            }
        }
    }
}
@media (max-width: 768.98px) {
    .selection {
        &__item {
            &:hover {
                scale: 1;
            }
        }
        &__slider {
            .swiper {
                padding-left: 0;
                padding: 0;
                &-slide {
                    width: 28vw;
                }
                &-wrapper {
                    overflow-x: auto;
                    overflow-y: hidden;
                    padding: 0 var(--paddingLeft);
                    &::-webkit-scrollbar {
                        display: none;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 576px) {
    .selection {
        margin-bottom: 25px;
        &.similarVideo {
            .selection__item {
                &.loader {
                    min-width: calc(100vw / 2);
                }
            }
        }
        &__slider {
            .swiper {
                &-slide {
                    width: 38vw;
                }
            }
        }
        &__title {
            h2 {
                font-size: 20px;
            }
        }
    }
}
@media screen and (max-width: 540px) {
    .selection {
        --paddingLeft: 15px;
        &__item {
            &_img {
                height: 140px;
            }
            &_info {
                padding: 15px;
                width: 240px;
            }
        }
    }
}
</style>
